<template>
  <div>
    <div
      class="d-flex align-center justify-space-between mb-4 flex-wrap"
    >
      <activity-headline :reviews="reviews" />
      <activity-window-picker @changed="load" />
    </div>

    <v-text-field
      v-model="search"
      label="Search reviews"
      prepend-inner-icon="search"
      outlined
      dense
      hide-details
      clearable
      class="mb-4"
    />

    <v-data-table
      :headers="headers"
      :items="filteredReviews"
      :items-per-page="15"
      :loading="loading"
      item-key="reviewId"
      class="elevation-1"
      cypress-id="admin-review-activity-table"
      @click:row="openDetail"
    >
      <template #[`item.title`]="{ item }">
        <div class="d-flex align-center">
          <span>{{ item.title }}</span>
          <v-chip v-if="item.archived" class="ml-2" x-small outlined>
            Archived
          </v-chip>
        </div>
      </template>

      <template #[`item.progress`]="{ item }">
        {{ item.screenedCount }}/{{ item.totalReferences }} screened
      </template>

      <template #[`item.lastActivityAt`]="{ item }">
        {{ formatDate(item.lastActivityAt) }}
      </template>

      <template #[`item.weeklyActivity`]="{ item }">
        <v-sparkline
          :value="item.weeklyActivity.map((w) => w.count)"
          :smooth="4"
          auto-draw
          height="28"
        />
      </template>

      <template #[`item.timeSavedSeconds`]="{ item }">
        <span :title="timeSavedTooltip">
          {{ formatHours(item.timeSavedSeconds) }}
        </span>
      </template>
    </v-data-table>

    <review-activity-detail-panel
      v-model="detailOpen"
      :review-id="selectedReviewId"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ActivityWindowPicker from '@/components/AdminPage/ActivityWindowPicker';
import ActivityHeadline from '@/components/AdminPage/ActivityHeadline';
import ReviewActivityDetailPanel from '@/components/AdminPage/ReviewActivityDetailPanel';

export default {
  name: 'ReviewActivityTable',
  components: {
    ActivityWindowPicker,
    ActivityHeadline,
    ReviewActivityDetailPanel,
  },
  data: () => ({
    loading: false,
    search: '',
    detailOpen: false,
    selectedReviewId: null,
    timeSavedTooltip:
      'Estimate: (auto-excluded + duplicate references) × votes required × 45s per abstract',
    headers: [
      { text: 'Review', value: 'title' },
      { text: 'Progress', value: 'progress', sortable: false },
      { text: 'Screening votes', value: 'screeningVotes' },
      { text: 'Full-text votes', value: 'fullTextVotes' },
      { text: 'Comments', value: 'comments' },
      { text: 'Active members', value: 'activeMemberCount' },
      { text: 'Last activity', value: 'lastActivityAt' },
      { text: 'Activity', value: 'weeklyActivity', sortable: false },
      { text: 'Time saved', value: 'timeSavedSeconds' },
    ],
  }),
  computed: {
    ...mapState('adminActivity', ['reviews']),
    filteredReviews() {
      const q = (this.search || '').toLowerCase();
      return this.reviews.filter(
        (r) => !q || r.title.toLowerCase().includes(q)
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          'adminActivity/fetchReviewActivity',
          {}
        );
      } finally {
        this.loading = false;
      }
    },
    openDetail(row) {
      this.selectedReviewId = row.reviewId;
      this.detailOpen = true;
    },
    formatHours(seconds) {
      return `${(seconds / 3600).toFixed(1)} h`;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-AU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
};
</script>
